export default __webpack_public_path__ + "static/media/redCanvas.2f3ec8d5.PNG";